import type { VariantProps } from 'class-variance-authority'

import { cva } from 'class-variance-authority'

import { inputBaseClasses } from '../input/variants'
import { borderClassesError } from '../form/variants'

export const textareaVariants = cva(
  [
    ...inputBaseClasses,
    'flex',
    'min-h-20',
    'ring-offset-white',
    'dark:ring-offset-neutral-950',
  ],
  {
    variants: {
      hasError: {
        true: borderClassesError,
      },
    },
  },
)

export type TextareaVariants = VariantProps<typeof textareaVariants>
